<template>
	<div class="fixed bottom-5 right-5 md:bottom-10 md:right-10 z-[200]">
		<ButtonCta
			button-mode="dark"
			class="shadow-lg border border-idrive-hover"
			@click="handleModal"
		>
			<div class="flex flex-row gap-2 items-center">
				<IconGetInTouch />
				<span class="font-bold leading-none">Get in touch</span>
			</div>
		</ButtonCta>
	</div>
</template>

<script setup lang="ts">
import ButtonCta from '@/Components/ui/buttons/ButtonCta.vue'
import IconGetInTouch from '@/Components/ui/icons/IconGetInTouch.vue'

const emit = defineEmits(['onClick'])

const handleModal = () => {
	emit('onClick')
}
</script>
